export default {"src":"/_next/static/media/white-arrow.33e5af99.svg","height":6,"width":10,"blurWidth":0,"blurHeight":0};